import { useEffect, useRef } from "react";

import {
  notificationsSocketService,
  type VerificationSocketPayload,
} from "@/modules/dashboard/notifications/services/notifications-socket.service";

/**
 * Real-time verification verdicts (marcos A/C, authenticated). Subscribes to the `verification:updated` push
 * on the notifications socket (rule 10: reuse the singleton, never open a second socket) and filters by
 * `identityId`. This is the preferred channel; `useVerificationStatusPolling` stays as the fallback and the
 * two coexist (the engine's `applyStatus` is idempotent). No effect in the public frame (marco B), which runs
 * outside the dashboard where the socket isn't connected.
 */
export function useVerificationSocket(
  identityId: string | null | undefined,
  onUpdate: (payload: VerificationSocketPayload) => void,
): void {
  const onUpdateRef = useRef(onUpdate);
  useEffect(() => {
    onUpdateRef.current = onUpdate;
  });

  useEffect(() => {
    if (!identityId) return;
    return notificationsSocketService.onVerificationUpdate((payload) => {
      if (payload.identity_id === identityId) {
        onUpdateRef.current(payload);
      }
    });
  }, [identityId]);
}
